import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import FormSelect from '../../shared/FormSelect';
import FormCheckbox from '../../shared/FormCheckbox';
import { fetchGetLatestTemplateRiderComponent, fetchTemplateRiderComp } from '../../../utils/apiUtils';
import { SLOT_NAMES } from '../../../utils/constants';
import { useWatch } from 'react-hook-form';

const step = 11

const StepEleven = ({ activeStep, control, errors, register, getValues }) => {
    if (activeStep !== step) return;

    const [searchText, setSearchText] = useState('');
    const template = useWatch({ name: "template", control });
    const isPcpRequired = useWatch({ name: "rules.pcp.isRequired", control });
    const isReferralRequired = useWatch({ name: "rules.referral.isRequired", control });
    const referralDefault = useWatch({ name: "rules.referral.default", control });


    const { data: pcpRiders } = useQuery({
        queryKey: ['getPcpRules'],
        // queryFn: async () => {
        //     let hasMore;
        //     let searchAfter;
        //     const metadatas = []

        //     do {
        //         let params = {
        //             size: 10,
        //             //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //             benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
        //             category: SLOT_NAMES.RULES_NON_ELECTED_PCP,
        //             searchAfter,
        //             searchText
        //         };

        //         const sanitizedParams = Object.fromEntries(
        //             Object.entries(params).filter(([key, value]) => value)
        //         );

        //         const results = await fetchTemplateRiderComp(sanitizedParams);
        //         const hits = results.hits.hits

        //         hits.forEach(hit => { metadatas.push(hit._source.metadata) })

        //         const total = results.hits.total.value
        //         hasMore = metadatas?.length < total;
        //         searchAfter = hits.at(-1)?.sort
        //     } while (hasMore)

        //     return metadatas
        // },
        queryFn: async () => {

            const results = await fetchGetLatestTemplateRiderComponent({
                slotName: SLOT_NAMES.RULES_NON_ELECTED_PCP,
                benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
                searchText,
                limit: 100
            })
            return results.rows
        },
        enabled: !!template?.additional?.benefitPlanTemplateKey
    })

    const { data: referralRiders } = useQuery({
        queryKey: ['getReferrralRules'],
        // queryFn: async () => {
        //     let hasMore;
        //     let searchAfter;
        //     const metadatas = []

        //     do {
        //         let params = {
        //             size: 10,
        //             //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //             benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
        //             category: SLOT_NAMES.RULES_REFERRALS,
        //             searchAfter,
        //             searchText
        //         };

        //         const sanitizedParams = Object.fromEntries(
        //             Object.entries(params).filter(([key, value]) => value)
        //         );

        //         const results = await fetchTemplateRiderComp(sanitizedParams);
        //         const hits = results.hits.hits

        //         hits.forEach(hit => { metadatas.push(hit._source.metadata) })

        //         const total = results.hits.total.value
        //         hasMore = metadatas?.length < total;
        //         searchAfter = hits.at(-1)?.sort
        //     } while (hasMore)

        //     return metadatas
        // },

        queryFn: async () => {

            const results = await fetchGetLatestTemplateRiderComponent({
                slotName: SLOT_NAMES.RULES_REFERRALS,
                benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
                searchText,
                limit: 100
            })
            return results.rows
        },

        enabled: !!template?.additional?.benefitPlanTemplateKey
    })

    const { data: bnefitDeterminatonOrderOptions } = useQuery({
        queryKey: ['getBenefitDeterminatonOrder'],
        // queryFn: async () => await fetchTemplateRiderComp({
        //     category: SLOT_NAMES.BENEFIT_DETERMINATION,
        //     //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey
        // }),
        // select: (data) => data.hits.hits.map(({ _source: { metadata } }, i) => ({
        //     value: metadata.benefitPlanRiderHccId,
        //     label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //     additional: metadata,
        // })),

        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.BENEFIT_DETERMINATION,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),

        enabled: !!template?.additional?.benefitPlanTemplateKey,
    })

    // if (!isPcpRequired) {
    //     setValue('rules.pcp.penaltyOption', null)
    //     setValue('rules.pcp.penaltyAmt', null)
    // }

    // combination of these 2 selection will be one component
    return (
        <>
            {activeStep === step && template?.label === 'Traditional Product Template' ? <div>PCP or referrals are not required for Traditional Templates.</div>
                : <>
                    <p style={{ fontSize: '1.2rem', fontWeight: '600', padding: '0rem 0rem 1rem 0rem' }}>Primary Care Physician Rules</p>

                    <FormCheckbox
                        label={`Is PCP required`}
                        name={`rules.pcp.isRequired`}
                        register={register}
                        control={control}
                        style={{ paddingBottom: '2rem' }}
                    />

                    {isPcpRequired && <div style={{ display: 'flex', gap: '1rem' }}>
                        <FormSelect
                            label={'Penalty Option'}
                            name={'rules.pcp.penaltyOption'}
                            control={control}
                            options={pcpRiders?.filter(d => d.benefitPlanRiderHccId).map(d => ({ value: d.benefitPlanRiderHccId, label: d.benefitPlanRiderHccId, additional: d }))}
                            errors={errors}
                            placeholder="Select..."
                        />
                        {/* <FormInputNumber name={"rules.pcp.penaltyAmt"} label={`Penalty Amount`} errors={errors} register={register} style={{ width: '200px' }} /> */}

                    </div>
                    }

                    <p style={{ fontSize: '1.2rem', fontWeight: '600', padding: '2rem 0rem 1rem 0rem' }}>Referral Rules</p>

                    <FormCheckbox
                        label={`Is Referral required`}
                        name={`rules.referral.isRequired`}
                        register={register}
                        control={control}
                        style={{ paddingBottom: '2rem' }}
                    />

                    {isReferralRequired && <div style={{}}>

                        <div className="form-input">
                            <label htmlFor={'coverageTierSet'}>Penalty Option default (from template)</label>
                            <input
                                style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                                type="text"
                                id={"referralDefault"}
                                disabled={true}
                                // list="items"
                                autoComplete="off"
                                // onFocus={() => setCurrentPage(0)}
                                // onChange={(e) => {
                                //     setSearchValue(e.target.value);
                                //     debouncedChangeHandler(e);
                                // }}
                                value={referralDefault?.value}
                            />
                        </div>

                        <FormSelect
                            label={'Penalty Option overwrite'}
                            name={'rules.referral.penaltyOption'}
                            control={control}
                            options={referralRiders?.filter(d => d.benefitPlanRiderHccId).map(d => ({ value: d.benefitPlanRiderHccId, label: d.benefitPlanRiderHccId }))}
                            errors={errors}
                            placeholder="Select..."
                        />
                        {/* <FormInputNumber name={"rules.referral.penaltyAmt"} label={`Penalty Amount`} errors={errors} register={register} style={{ width: '200px' }} /> */}

                    </div>
                    }
                </>}


            <p style={{ fontSize: '1.2rem', fontWeight: '600', padding: '2rem 0rem 1rem 0rem' }}>Benefit Determination Order</p>

            <div className="form-input">
                <label htmlFor={'coverageTierSet'}>Default (from HCC level)</label>
                <input
                    style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                    type="text"
                    placeholder="search..."
                    disabled={true}
                    // list="items"
                    autoComplete="off"

                    value={`Deductible > Copay > Coinsurance`}
                />
            </div>

            <FormSelect
                label={'Determination Order Overwrite'}
                name={'rules.benefitDeterminatonOrder'}
                control={control}
                options={bnefitDeterminatonOrderOptions}
                errors={errors}
                placeholder="Select..."
                disabled={false}
            />

            {/* <p style={{ padding: '1rem', backgroundColor: 'var(--lightestGrey)', width: 'fit-content', borderRadius: '.4rem' }}>{bnefitDeterminatonOrderOptions?.[0]?.label}</p> */}
        </>
    )
}

export default StepEleven
